import {
  AdditionalWorkspaceDecision,
  fetchAdditionalWorkspaceDecision,
  PortalSetupApiConfig,
} from 'src/clients/portalSetupApiBaseUrl';

const allowedDecision = (): AdditionalWorkspaceDecision => ({
  allowed: true,
  portalId: '',
  portalUrl: '',
});

/**
 * A network failure leaves the answer unknown. The create call still refuses
 * a free email, so the UI can continue and surface that refusal.
 */
export const additionalWorkspaceDecision = async (
  portalConfig: PortalSetupApiConfig,
  email: string,
): Promise<AdditionalWorkspaceDecision> => {
  const trimmed = email.trim();
  if (!trimmed) {
    return allowedDecision();
  }
  try {
    return await fetchAdditionalWorkspaceDecision(portalConfig, trimmed);
  } catch (error) {
    console.error('additional workspace check failed', error);
    return allowedDecision();
  }
};

export const additionalWorkspaceAllowed = async (
  portalConfig: PortalSetupApiConfig,
  email: string,
): Promise<boolean> => {
  const decision = await additionalWorkspaceDecision(portalConfig, email);
  return decision.allowed;
};
